import MsDyn365, { ICoreContext } from '@msdyn365-commerce/core';

export const getPublicAssetPath = (context: ICoreContext, publicFolderAssetPath: string) => {
    const staticCdnUrl = context.request.url.staticCdnUrl;
    const submissionId = MsDyn365.getEnvironmentVariable('SUBMISSIONID');
    return `${staticCdnUrl}${submissionId}/${publicFolderAssetPath}`;
};

// It is not very reliable to determine the home page based on telemetry page name,
// but we have not figured out a better way to do it so far, so we have to live with this.
export const isInHomePage = (context: ICoreContext): boolean => {
    return !!context.request.telemetryPageName?.includes('Home');
};
